import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { useAuth } from '../contexts/AuthContext';

export const usePageTracking = () => {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    const trackPageView = async () => {
      if (!user || !location.pathname) return;

      // Skip tracking for these paths
      const ignorePaths = ['/login', '/signup'];
      if (ignorePaths.includes(location.pathname)) return;

      try {
        const pageActivityRef = collection(db, 'pageActivity');
        await addDoc(pageActivityRef, {
          userId: user.uid,
          path: location.pathname,
          timestamp: serverTimestamp(),
          visitedAt: new Date().toISOString()
        });
      } catch (error) {
        // Silently handle tracking errors to prevent app disruption
        console.debug('Page tracking error:', error);
      }
    };

    trackPageView();
  }, [location.pathname, user]);
};
